import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../assets/img/left.png'
import _imports_1 from '../assets/img/right.png'


const _hoisted_1 = { class: "page-home" }
const _hoisted_2 = { class: "show-box" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "info-box" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "info-box-top" }, null, -1)
const _hoisted_6 = { class: "info-box-wrapper" }
const _hoisted_7 = { class: "info-other" }
const _hoisted_8 = { class: "info-other-top" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon left"
}, null, -1)
const _hoisted_10 = { class: "center" }
const _hoisted_11 = {
  key: 0,
  class: "name"
}
const _hoisted_12 = { class: "center-bottom" }
const _hoisted_13 = { class: "num" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "限量", -1)
const _hoisted_15 = {
  key: 0,
  class: "group set"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "icon"
}, null, -1)
const _hoisted_17 = { class: "info-other-price" }
const _hoisted_18 = {
  key: 0,
  class: "price"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 1,
  class: "num"
}
const _hoisted_21 = { class: "info-other-bottom cursor" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "链上信息 ", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "more" }, ">", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "info-detail-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line" }),
  /*#__PURE__*/_createElementVNode("span", null, "详细信息"),
  /*#__PURE__*/_createElementVNode("span", { class: "line" })
], -1)
const _hoisted_26 = {
  key: 0,
  class: "info-detail-box"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "藏品描述", -1)
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 1,
  class: "info-detail-box"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "藏品故事", -1)
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = {
  key: 0,
  class: "content red"
}
const _hoisted_33 = { class: "button-box" }
const _hoisted_34 = {
  key: 0,
  class: "button-box-wrapper"
}
const _hoisted_35 = {
  key: 1,
  class: "button-box-wrapper"
}
const _hoisted_36 = {
  key: 1,
  class: "button disabled"
}
const _hoisted_37 = {
  key: 2,
  class: "button disabled"
}
const _hoisted_38 = {
  key: 0,
  class: "success-box"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "success-content" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "value" }, "恭喜您，收藏成功！")
], -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "lian-content" }
const _hoisted_42 = { class: "group" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "商品标识:", -1)
const _hoisted_44 = { class: "content" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "zhu" }, "注：商品标识是本数字藏品在区块链上的唯一ID", -1)
const _hoisted_46 = { class: "group" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "交易哈希：", -1)
const _hoisted_48 = { class: "content" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "zhu" }, "注：交易哈希是您拥有本数字藏品所有权的证明", -1)
const _hoisted_50 = {
  key: 2,
  class: "order-flag"
}
const _hoisted_51 = { class: "flag-content flag-center" }
const _hoisted_52 = { class: "flag-title" }
const _hoisted_53 = { class: "flag-title" }
const _hoisted_54 = { class: "flag-btns" }
const _hoisted_55 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.infoData.img_url)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.infoData.img_url
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_ctx.infoData.name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.infoData.name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(_toDisplayString(_ctx.infoData.num) + "件", 1)
                ]),
                (_ctx.infoData.set_name)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.infoData.set_name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_16
          ]),
          _createElementVNode("div", _hoisted_17, [
            (parseFloat(_ctx.infoData.price)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_ctx.infoData.priceString)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.infoData.priceString), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.infoData.is_collect && ( _ctx.infoData.left_num > 0 || _ctx.infoData.left_num == 0))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, "剩余" + _toDisplayString(_ctx.infoData.left_num) + "件", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", {
              class: "group lian",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openInfo()))
            }, _hoisted_24)
          ])
        ]),
        _hoisted_25,
        (_ctx.infoData.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("p", {
                class: "content",
                innerHTML: _ctx.infoData.description
              }, null, 8, _hoisted_28)
            ]))
          : _createCommentVNode("", true),
        (_ctx.infoData.story)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("p", {
                class: "content",
                innerHTML: _ctx.infoData.story
              }, null, 8, _hoisted_31),
              (parseFloat(_ctx.infoData.price)>0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, " 支付成功后，在我的-消息中心-通知中，查看订单详情 "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      (!_ctx.isApp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            (!_ctx.isFromMy)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button download-btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goApp(206)))
                }, "收藏"))
              : _createCommentVNode("", true),
            (!_ctx.isFromMy)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "button download-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goApp(207)))
                }, "查看藏品"))
              : _createCommentVNode("", true),
            (_ctx.isFromMy)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "button download-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goApp(206)))
                }, "我也要收藏"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isApp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            (!_ctx.isLogin || (_ctx.isLogin && !_ctx.infoData.is_collect && (_ctx.infoData.has_num || _ctx.infoData.has_order)))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goCang()))
                }, "收藏"))
              : _createCommentVNode("", true),
            (_ctx.isLogin && _ctx.infoData.is_collect)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, "已收藏"))
              : _createCommentVNode("", true),
            (_ctx.isLogin && !_ctx.infoData.is_collect && !_ctx.infoData.has_num && !_ctx.infoData.has_order)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, "藏品已领完"))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goMyCollection()))
            }, "查看藏品")
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.successFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
      : _createCommentVNode("", true),
    (_ctx.infoFlag)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "lian-box",
          onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.openInfo()), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              (_ctx.infoData.goods_id )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "copy",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copy(_ctx.infoData.goods_id)))
                  }, "复制"))
                : _createCommentVNode("", true),
              _hoisted_43,
              _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.infoData.goods_id || '处理中...'), 1),
              _hoisted_45
            ]),
            _createElementVNode("div", _hoisted_46, [
              (_ctx.infoData.block_hash )
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "copy",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.copy(_ctx.infoData.block_hash)))
                  }, "复制"))
                : _createCommentVNode("", true),
              _hoisted_47,
              _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.infoData.block_hash || '处理中...'), 1),
              _hoisted_49
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.payFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("p", _hoisted_52, "剩余支付时间：" + _toDisplayString(Math.floor(_ctx.timerData/60>0) ? (Math.floor(_ctx.timerData/60>0) < 10 ? '0'+Math.floor(_ctx.timerData/60): Math.floor(_ctx.timerData/60)) : '00') + ":" + _toDisplayString(Math.floor(_ctx.timerData%60>0) ? (Math.floor(_ctx.timerData%60)<10? '0'+ Math.floor(_ctx.timerData%60):Math.floor(_ctx.timerData%60)) : '00'), 1),
            _createElementVNode("p", _hoisted_53, "是否确认支付" + _toDisplayString(_ctx.infoData.priceString) + "购买" + _toDisplayString(_ctx.infoData.name) + "?", 1),
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                class: "flag-btns-ok",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pay())),
                disabled: _ctx.timerData>0 ? false: true
              }, "去支付", 8, _hoisted_55),
              _createElementVNode("button", {
                class: "flag-btns-cancel",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancelPay()))
              }, "取消")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}